import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import axiosClient from '../../../shared/axios/axios-client';

export interface GrupoContato {
  nome: string;
  cargo: string;
  email: string;
  telefone: string;
}

export interface CriarGrupo {
  nome: string;
  contato: GrupoContato;
}

export interface Grupo {
  id: number;
  nome: string;
}

export interface GrupoDetalhado extends Grupo {
  contatos: GrupoContato[];
  empresas: any[];
}

export interface EmpresaGrupo {
  id: number;
  nomeFantasia: string;
  razaoSocial: string;
  cnpj: string;
  estado: string;
  cidade: string;
}

@Injectable({
  providedIn: 'root',
})
export class GruposService {
  private apiUrl = environment.apiUrl;

  constructor() {}

  async criarGrupo(grupo: CriarGrupo): Promise<Grupo> {
    const response = await axiosClient.post('/grupo', grupo);
    return response.data;
  }

  async buscarGrupos(): Promise<Grupo[]> {
    const response = await axiosClient.get('/grupo');
    return response.data;
  }

  async buscarGrupoPorId(id: number): Promise<GrupoDetalhado> {
    const response = await axiosClient.get(`/grupo/${id}`);
    return response.data;
  }

  async buscarEmpresasDoGrupo(idGrupo: number): Promise<EmpresaGrupo[]> {
    const response = await axiosClient.get(`/grupo/${idGrupo}/empresas`);
    return response.data;
  }

  buscarGruposVinculadosAoUsuario(): Observable<Grupo[]> {
    const url = `${this.apiUrl}/grupo/vinculados-usuario`;
    return from(axiosClient.get<Grupo[]>(url).then((res) => res.data));
  }

  async deletarGrupo(id: number): Promise<void> {
    await axiosClient.delete(`/grupo/${id}`);
  }

  async atualizarGrupo(grupo: any): Promise<GrupoDetalhado> {
    const response = await axiosClient.put('/grupo', grupo);
    return response.data;
  }

  async vincularEmpresasAoGrupo(idGrupo: number, empresasIds: number[]): Promise<void> {
    await axiosClient.post(`/grupo/${idGrupo}/empresas`, empresasIds);
  }

  async removerEmpresaDoGrupo(idGrupo: number, empresaId: number): Promise<void> {
    await axiosClient.delete(`/grupo/${idGrupo}/empresas/${empresaId}`);
  }
}